import { useMutation } from 'react-query';
import { useToastContext } from 'shared/components/Toast/context/ToastContext';
import { procedureService } from 'shared/services/ProcedureService';

export const useDeleteProcedure = () => {
    const { showToast } = useToastContext();

    const { mutateAsync, isError, isLoading } = useMutation(
        (procedureID: number) => {
            return procedureService.deleteProcedure(procedureID);
        },
        {
            onSuccess: () => {
                showToast('success', 'Procedure deleted');
            },
            onError: (error: any) => {
                console.log('Error on posting procedure - ');
                showToast('error', error?.detail);
            },
        }
    );

    return {
        mutateAsync,
        isLoading,
        serverErrorMessage: isError,
    };
};
